import api from './interceptor';

const BASE_URL_V2 = 'api/v2/rpm-templates';

export default {
  // API Version 2
  getRpmTemplateList: params => api.get(`${BASE_URL_V2}`, { params }),
  createRpmTemplate: params => api.post(`${BASE_URL_V2}`, params),
  updateRpmTemplate: (templateId, params) => api.put(`${BASE_URL_V2}/${templateId}`, params),
  deleteRpmTemplate: templateId => api.delete(`${BASE_URL_V2}/${templateId}`),
};
